import { writable } from 'svelte/store';
import '../ui-elements/element';
import './types';
import { saveConfig } from '../services/storage.service';
export const storageKey = 'uiElements';
let initialLoaded = false;
function getInitState() {
    return {
        currentPage: 'Page 1',
        pages: { 'Page 1': { elements: {}, swipeable: false } },
        projectName: 'Banglejs GUI'
    };
}
export function createGUICreatorDataStore() {
    const { subscribe, set, update } = writable(getInitState());
    let currentValue = getInitState();
    let renderOrder = {};
    subscribe((guiCreatorData) => {
        currentValue = guiCreatorData;
    });
    subscribe((guiCreatorData) => {
        if (!initialLoaded) {
            initialLoaded = true;
            return;
        }
        saveConfig(guiCreatorData);
    });
    function updateGuiCreatorData(uiElement) {
        return (guiCreatorData) => {
            const { currentPage } = currentValue;
            if (!guiCreatorData.pages[currentPage]) {
                guiCreatorData.pages[currentPage].elements = {};
            }
            guiCreatorData.pages[currentPage].elements[uiElement.id] = uiElement;
            updateRenderOrder(guiCreatorData, currentPage);
            return Object.assign({}, guiCreatorData);
        };
    }
    function updateRenderOrder(guiCreatorData, page) {
        renderOrder[page] = Object.keys(guiCreatorData.pages[page].elements)
            .map((elementKey) => guiCreatorData.pages[page].elements[elementKey])
            .sort(orderByZValue);
    }
    function orderByZValue(uiElementA, uiElementB) {
        if (uiElementA.z > uiElementB.z)
            return 1;
        if (uiElementA.z < uiElementB.z)
            return -1;
        return 0;
    }
    return {
        subscribe,
        add: (uiElement) => {
            if (Object.keys(currentValue.pages).length === 0) {
                currentValue.pages['Page 1'].elements = {};
                currentValue.currentPage = 'Page 1';
            }
            update(updateGuiCreatorData(uiElement));
        },
        update: (uiElement) => {
            update(updateGuiCreatorData(uiElement));
        },
        updateProjectName: (projectName) => {
            update((guiCreatorData) => {
                guiCreatorData.projectName = projectName;
                return guiCreatorData;
            });
        },
        updateSwipeable: (pageKey, swipeableValue) => {
            update((guiCreatorData) => {
                if (guiCreatorData.pages[pageKey]) {
                    guiCreatorData.pages[pageKey].swipeable = swipeableValue;
                }
                return guiCreatorData;
            });
        },
        updateMultiple: (uiElements, updatePage) => update((storeElements) => {
            let newStoreData = storeElements;
            if (!newStoreData.pages[updatePage].elements) {
                newStoreData.pages[updatePage].elements = {};
            }
            uiElements.forEach(uiElement => {
                newStoreData = updateGuiCreatorData(uiElement)(newStoreData);
            });
            return Object.assign({}, newStoreData);
        }),
        removeByIds: (ids) => {
            update(elements => {
                ids.forEach(id => {
                    delete elements.pages[currentValue.currentPage].elements[id];
                });
                updateRenderOrder(currentValue, currentValue.currentPage);
                return Object.assign({}, elements);
            });
        },
        reset: () => {
            set(getInitState());
            renderOrder = {};
        },
        setCurrentPage: (newPage) => {
            const newValue = currentValue;
            newValue.currentPage = newPage;
            set(newValue);
        },
        updatePage: (oldPage, newPage) => {
            const updatedGuiCreatorData = currentValue;
            const oldPageData = currentValue.pages[oldPage];
            if (!updatedGuiCreatorData.pages[newPage]) {
                updatedGuiCreatorData.pages[newPage] = {
                    elements: oldPageData.elements || {},
                    swipeable: oldPageData.swipeable,
                };
            }
            else {
                updatedGuiCreatorData.pages[newPage].elements = oldPageData.elements || {};
            }
            delete updatedGuiCreatorData.pages[oldPage];
            if (updatedGuiCreatorData.currentPage === oldPage) {
                updatedGuiCreatorData.currentPage = newPage;
            }
            set(updatedGuiCreatorData);
        },
        addPage: (newPage) => {
            currentValue.pages[newPage] = { elements: {}, swipeable: false, };
            currentValue.currentPage = newPage;
            set(currentValue);
        },
        deletePage: (pageToDelete) => {
            delete currentValue.pages[pageToDelete];
            if (currentValue.currentPage === pageToDelete) {
                currentValue.currentPage = '';
            }
            if (Object.keys(currentValue.pages).length > 0) {
                currentValue.currentPage = Object.keys(currentValue.pages)[0];
            }
            set(currentValue);
        },
        set: (guiCreatorData) => {
            set(guiCreatorData);
            Object.keys(guiCreatorData.pages).forEach(pageKey => updateRenderOrder(guiCreatorData, pageKey));
        },
        get: () => currentValue,
        getAllElementsAsList: () => {
            const elementList = [];
            Object.keys(currentValue.pages).forEach(pageKey => {
                const page = currentValue.pages[pageKey];
                Object.keys(page.elements).forEach(elementKey => {
                    elementList.push(page.elements[elementKey]);
                });
            });
            return elementList;
        },
        getRenderOrder: (page) => renderOrder[page] || [],
    };
}
export const guiCreatorDataStore = createGUICreatorDataStore();
